import axios from 'axios'
import { BUSCAR_TIPOS_DOCUMENTOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { RESPONSE_ERROR_HANDLER_POSTPONE_HEADER } from '../../util/responseUtil'
import { URL } from '../../util/ambienteActions';

const CACHE_KEY = 'vexado_tipos_documentos';

const OFFLINE_AWARE_CONFIG = {
  headers: {
    ...SLOW_REQUEST_CONFIG.headers,
    [RESPONSE_ERROR_HANDLER_POSTPONE_HEADER]: true
  }
}

export default () => dispatch => axios.get(`${URL}/pessoas/tipos-documentos`, OFFLINE_AWARE_CONFIG)
  .then(response => {
    try { localStorage.setItem(CACHE_KEY, JSON.stringify(response.data)); } catch (_) { // ignore
    }
    return dispatch({ type: BUSCAR_TIPOS_DOCUMENTOS, payload: response });
  })
  .catch(erro => {
    if (!navigator.onLine || !erro.response) {
      try {
        const cache = localStorage.getItem(CACHE_KEY);
        if (cache) return dispatch({ type: BUSCAR_TIPOS_DOCUMENTOS, payload: { data: JSON.parse(cache) } });
      } catch (_) { // ignore
      }
      return dispatch({ type: BUSCAR_TIPOS_DOCUMENTOS, payload: { data: [] } });
    }
    throw erro;
  });
